import { isFlaggedMature, isShallowContent } from './util';
const ERROR_OBJECT_TYPES = ['NotFoundError', 'ServerError'];
// The *shared* logic between the isVideoAdSuppressed and areAdsEnabled; we
// want to keep these functions as tightly coupled as possible, because
// JWPlayer has issues trying to play a monetized video on a demonetized page.
// We keep the video-specific checks from touching general ContentItems by
// duck-typing. (Similarly, video ads cannot be shallow because they do not
// have bodyTml.)
//
// Note that `areAdsEnabled` doesn't care about the exact reasons.
const suppressAdItem = (adConfig, item, channelCode, name) => {
    const reasons = [];
    const noAdStates = ['demonetized', 'review_required'];
    const directAllowedChannels = ['web'];
    if (!directAllowedChannels.includes(channelCode ?? '')) {
        noAdStates.push('direct_only');
    }
    const consolidateTerms = (item) => (item.terms ?? []).concat(item.associatedRichTerms ?? []);
    if (!adConfig.enabled) {
        reasons.push('site');
    }
    // Error pages do not show ads
    if (ERROR_OBJECT_TYPES.includes(item?.objectType ?? '')) {
        reasons.push('error-page');
    }
    if (noAdStates.includes(item?.monetizationState?.value ?? '')) {
        reasons.push(name + '-demonetized');
    }
    if (Object.hasOwnProperty.call(item, 'videoPlatformAdsEnabled') &&
        item.videoPlatformAdsEnabled !== false) {
        reasons.push(name);
    }
    if (Object.hasOwnProperty.call(item, 'contentRating') && item.contentRating === 'TV-MA') {
        // Note that we wish to make the contentRating more flexible, which will
        // probably require us to change this behavior at some point.
        reasons.push('rating');
    }
    if (isFlaggedMature(consolidateTerms(item))) {
        reasons.push(name + '-mature');
    }
    if (Object.hasOwnProperty.call(item, 'bodyTml') &&
        isShallowContent(item, adConfig.shallowContent ?? {})) {
        reasons.push(name + '-shallow');
    }
    if (name === 'parent' && item.isSponsored === true) {
        // We want to avoid demonetizing sponsored items to avoid upsetting any
        // business logic dependent on the ad stack, but we can't play
        // monetized videos on a sponsored page due to JWPlayer limitations.
        reasons.push(name + '-sponsored');
    }
    return reasons;
};
/**
 * The general page demonetization performs the following checks:
 * - Are ads disabled in the site config?
 * - Are display ads disabled in the view meta (in the template), e.g
 *   as we do for some BasicPages?
 * - Is it an error page?
 * - Is the monetization state indicative of demonetization?
 * - Is the content shallow, if we have enabled the optional check?
 * - Are any of the rich terms flagged as mature?
 */
export const areAdsEnabledWithReasons = (siteConfig, item, viewProperties, channelCode) => {
    let reasons = [];
    if (viewProperties?.viewMeta?.suppressDisplayAds === true) {
        reasons.push('template');
    }
    reasons = reasons.concat(suppressAdItem(siteConfig.ad ?? { enabled: false }, item, channelCode, 'item'));
    return reasons.length ? { enabled: false, reasons } : { enabled: true, reasons: null };
};
export default areAdsEnabledWithReasons;
//# sourceMappingURL=areAdsEnabledWithReasons.js.map